export default __webpack_public_path__ + "static/media/BLR7.944a25af.jpg";